module.exports = __webpack_public_path__ + "static/media/570.253f94b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/vehicleDetail/images/570.png
// module id = 779
// module chunks = 0